import React, { useState } from "react";
import { Oval } from "react-loader-spinner";

const MessagingPage = ({ 
  manualPhone, setManualPhone, addManualContact, fileInputRef, 
  handleFileUpload, isUploading, uploadStats, removeContact, 
  messageData, setMessageData, handleSendMessage, isSending, 
  historyData, scheduledData, handleRetryMessage, handleDeleteScheduled,
  filterParams, setFilterParams, handleFilterMessages, handleUpdateScheduledTime 
}) => {

  const [histPage, setHistPage] = useState(1);
  const [histLimit, setHistLimit] = useState(10);

  const [schedPage, setSchedPage] = useState(1);
  const [schedLimit, setSchedLimit] = useState(10);

  const [editingSchedId, setEditingSchedId] = useState(null);
  const [editSchedTime, setEditSchedTime] = useState("");

  const paginatedHistory = historyData.slice((histPage - 1) * histLimit, histPage * histLimit);
  const totalHistPages = Math.ceil(historyData.length / histLimit) || 1;

  const paginatedScheduled = scheduledData?.slice((schedPage - 1) * schedLimit, schedPage * schedLimit) || [];
  const totalSchedPages = Math.ceil((scheduledData?.length || 0) / schedLimit) || 1;

  return (
    <div className="view-container">
      <div className="page-header">
        <h1>Campaign Control Center</h1>
      </div>

      <div className="panel-grid">
        {/* AUDIENCE CARD */}
        <div className="card">
          <h2 className="card-title">Audience</h2>
          <label className="form-label">Contact</label>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '1rem' }}>
            <input type="tel" className="form-input" placeholder="+2547..." value={manualPhone} onChange={e => setManualPhone(e.target.value)} style={{ marginBottom: 0 }} />
            <button type="button" className="btn-primary" style={{ width: 'auto' }} onClick={addManualContact}>Add</button>
          </div>

          <input type="file" accept=".xlsx, .xls, .csv" style={{ display: "none" }} ref={fileInputRef} onChange={handleFileUpload} />
          
          <div style={{ border: '2px dashed var(--border)', padding: '1.5rem', borderRadius: '12px', textAlign: 'center', cursor: 'pointer', background: 'rgba(0,0,0,0.1)' }} onClick={() => fileInputRef.current.click()}>
            <span style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
              {isUploading ? "Uploading..." : "Import Excel/CSV Manifest"}
            </span>
          </div>

          {/* Download Template Link */}
          <div style={{ marginTop: '0.75rem', textAlign: 'center' }}>
            <a 
              href="/contacts.xlsx" 
              download="contacts_template.xlsx"
              style={{ color: 'var(--primary)', fontSize: '0.85rem', textDecoration: 'none', fontWeight: 500 }}
            >
              ↓ Download Excel Template
            </a>
          </div>

          <div style={{ maxHeight: '200px', overflowY: 'auto', marginTop: '1.5rem', background: '#111827', borderRadius: '8px', border: '1px solid var(--border)' }}>
            {uploadStats.contacts.length === 0 ? (
              <div style={{ padding: "1.5rem", textAlign: "center", color: "var(--text-muted)", fontSize: "0.85rem" }}>No contacts added</div>
            ) : (
              uploadStats.contacts.map((contact, index) => (
                <div key={index} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.75rem 1rem', borderBottom: '1px solid var(--border)' }}>
                  <span style={{ fontSize: '0.9rem' }}>{contact.phone_number}</span>
                  <button type="button" onClick={() => removeContact(index)} style={{ background: 'none', border: 'none', color: 'var(--danger)', cursor: 'pointer' }}>✕</button>
                </div>
              ))
            )}
          </div>
        </div>

        {/* MESSAGE CARD */}
        <div className="card">
          <h2 className="card-title">Message</h2>
          <label className="form-label">Content</label>
          <textarea className="form-textarea" placeholder="Enter message..." value={messageData.message} onChange={e => setMessageData({ ...messageData, message: e.target.value })} rows="5"></textarea>
          <div style={{ textAlign: 'right', fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '-8px', marginBottom: '1rem' }}>{messageData.message.length} characters</div>

          <label className="form-label">Category</label>
          <div style={{ display: 'flex', gap: '1.5rem', marginBottom: '1.5rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.9rem' }}>
              <input type="radio" name="sendType" value="now" checked={messageData.sendType === "now"} onChange={e => setMessageData({ ...messageData, sendType: e.target.value })} /> send now
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.9rem' }}>
              <input type="radio" name="sendType" value="scheduled" checked={messageData.sendType === "scheduled"} onChange={e => setMessageData({ ...messageData, sendType: e.target.value })} /> schedule for later
            </label>
          </div>

          {messageData.sendType === "scheduled" && (
            <div style={{ marginBottom: '1.5rem' }}>
              <label className="form-label">Timestamp</label>
              <input type="datetime-local" className="form-input" value={messageData.scheduledTime} onChange={e => setMessageData({ ...messageData, scheduledTime: e.target.value })} />
            </div>
          )}

          <button type="button" className="btn-primary" onClick={handleSendMessage} disabled={isSending}>
            {isSending ? <Oval height={18} width={18} color="#fff" /> : "send message"}
          </button>
        </div>
      </div>

      {/* SCHEDULED MESSAGES SECTION */}
      <div className="card" style={{ marginTop: '2rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
          <h2 className="card-title" style={{ margin: 0 }}>Scheduled Messages</h2>
          
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', fontSize: '0.85rem', color: 'var(--text-muted)' }}>
            <span>Rows:</span>
            <select style={{ background: '#09090b', color: '#fff', border: '1px solid var(--border)', borderRadius: '4px', padding: '2px 8px' }} value={schedLimit} onChange={(e) => { setSchedLimit(Number(e.target.value)); setSchedPage(1); }}>
              <option value={10}>10</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        </div>

        <div style={{ width: '100%', overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.9rem' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid var(--border)', color: 'var(--text-muted)' }}>
                <th style={{ padding: '1rem' }}>Scheduled Time</th>
                <th style={{ padding: '1rem' }}>Phone Number</th>
                <th style={{ padding: '1rem' }}>Message</th>
                <th style={{ padding: '1rem' }}>Status</th>
                <th style={{ padding: '1rem' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedScheduled.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
                    no scheduled messages
                  </td>
                </tr>
              ) : (
                paginatedScheduled.map((sched, index) => {
                  const rawDate = sched.scheduled_time || sched.scheduledtime;
                  const formattedDate = rawDate ? new Date(rawDate).toLocaleString('en-GB', { hour12: true }) : "N/A";
                  const isEditing = editingSchedId === sched.id;

                  return (
                    <tr key={index} style={{ borderBottom: '1px solid var(--border)' }}>
                      <td style={{ padding: '1rem', fontFamily: 'monospace', color: 'var(--text-main)' }}>
                        {isEditing ? (
                          <input 
                            type="datetime-local" 
                            className="form-input" 
                            style={{ padding: '6px', fontSize: '0.8rem', marginBottom: 0, width: 'auto' }} 
                            value={editSchedTime} 
                            onChange={(e) => setEditSchedTime(e.target.value)} 
                          />
                        ) : (
                          formattedDate
                        )}
                      </td>
                      <td style={{ padding: '1rem', color: 'var(--text-main)' }}>{sched.phone || sched.phones || "Empty"}</td>
                      <td style={{ padding: '1rem', color: 'var(--text-main)' }}>
                        {sched.message ? sched.message.substring(0, 45) + (sched.message.length > 45 ? "..." : "") : "Empty"}
                      </td>
                      <td style={{ padding: '1rem' }}>
                        <span style={{ color: 'var(--warning)', fontWeight: 600, fontSize: '0.85rem' }}>
                          {sched.status || "pending"}
                        </span>
                      </td>
                      <td style={{ padding: '1rem' }}>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          {isEditing ? (
                            <>
                              <button type="button" onClick={() => { handleUpdateScheduledTime(sched.id, editSchedTime); setEditingSchedId(null); }} style={{ background: 'rgba(16, 185, 129, 0.1)', color: '#10b981', border: '1px solid rgba(16, 185, 129, 0.2)', padding: '4px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 'bold' }}>Save</button>
                              <button type="button" onClick={() => setEditingSchedId(null)} style={{ background: 'transparent', color: 'var(--text-muted)', border: '1px solid var(--border)', padding: '4px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '0.75rem' }}>Cancel</button>
                            </>
                          ) : (
                            <>
                              <button type="button" onClick={() => { setEditingSchedId(sched.id); setEditSchedTime(rawDate); }} style={{ background: 'rgba(56, 189, 248, 0.1)', color: '#38bdf8', border: '1px solid rgba(56, 189, 248, 0.2)', padding: '4px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 'bold' }}>Edit</button>
                              <button type="button" onClick={() => handleDeleteScheduled(sched.id)} style={{ background: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', border: '1px solid rgba(239, 68, 68, 0.2)', padding: '4px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 'bold' }}>Delete</button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* SCHEDULED PAGINATION CONTROLS */}
        {scheduledData?.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', alignItems: 'center', marginTop: '1rem', fontSize: '0.85rem' }}>
            <button onClick={() => setSchedPage(p => Math.max(1, p - 1))} disabled={schedPage === 1} style={{ background: 'none', border: '1px solid var(--border)', color: 'var(--text-main)', padding: '4px 12px', borderRadius: '4px', cursor: schedPage === 1 ? 'not-allowed' : 'pointer' }}>Prev</button>
            <span style={{ color: 'var(--text-muted)' }}>Page {schedPage} of {totalSchedPages}</span>
            <button onClick={() => setSchedPage(p => Math.min(totalSchedPages, p + 1))} disabled={schedPage === totalSchedPages} style={{ background: 'none', border: '1px solid var(--border)', color: 'var(--text-main)', padding: '4px 12px', borderRadius: '4px', cursor: schedPage === totalSchedPages ? 'not-allowed' : 'pointer' }}>Next</button>
          </div>
        )}
      </div>

      {/* MESSAGE HISTORY SECTION */}
      <div className="card" style={{ marginTop: '2rem' }}>
        <h2 className="card-title" style={{ marginBottom: '1rem' }}>Message History</h2>
        
        {/* ADVANCED FILTER PANEL */}
        <div style={{ background: '#111827', padding: '1rem', borderRadius: '8px', border: '1px solid var(--border)', marginBottom: '1.5rem' }}>
          <form onSubmit={handleFilterMessages} style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div style={{ flex: '1', minWidth: '150px' }}>
              <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '4px' }}>Phone Number</label>
              <input type="text" className="form-input" placeholder="e.g. 2547..." value={filterParams.phone} onChange={e => setFilterParams({...filterParams, phone: e.target.value})} style={{ marginBottom: 0 }} />
            </div>
            <div style={{ flex: '1', minWidth: '150px' }}>
              <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '4px' }}>Start Date</label>
              <input type="date" className="form-input" value={filterParams.start_date} onChange={e => setFilterParams({...filterParams, start_date: e.target.value})} style={{ marginBottom: 0 }} />
            </div>
            <div style={{ flex: '1', minWidth: '150px' }}>
              <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '4px' }}>End Date</label>
              <input type="date" className="form-input" value={filterParams.end_date} onChange={e => setFilterParams({...filterParams, end_date: e.target.value})} style={{ marginBottom: 0 }} />
            </div>
            <div style={{ flex: '2', minWidth: '200px' }}>
              <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '4px' }}>Message Content</label>
              <input type="text" className="form-input" placeholder="Search text..." value={filterParams.message} onChange={e => setFilterParams({...filterParams, message: e.target.value})} style={{ marginBottom: 0 }} />
            </div>
            <div>
              <button type="submit" className="btn-primary" style={{ width: 'auto', padding: '10px 24px', marginBottom: '2px' }}>Search Logs</button>
            </div>
          </form>
        </div>

        {/* ROWS DROPDOWN */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '1rem', fontSize: '0.85rem', color: 'var(--text-muted)' }}>
          <span style={{ marginRight: '1rem' }}>Rows:</span>
          <select style={{ background: '#09090b', color: '#fff', border: '1px solid var(--border)', borderRadius: '4px', padding: '2px 8px' }} value={histLimit} onChange={(e) => { setHistLimit(Number(e.target.value)); setHistPage(1); }}>
            <option value={10}>10</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>

        <div style={{ width: '100%', overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.9rem' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid var(--border)', color: 'var(--text-muted)' }}>
                <th style={{ padding: '1rem' }}>Timestamp</th>
                <th style={{ padding: '1rem' }}>Channel</th>
                <th style={{ padding: '1rem' }}>Message</th>
                <th style={{ padding: '1rem' }}>Phone number</th>
                <th style={{ padding: '1rem' }}>Cost</th>
                <th style={{ padding: '1rem' }}>Status</th>
                <th style={{ padding: '1rem' }}>Webhook status</th>
                <th style={{ padding: '1rem' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedHistory.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
                    no messages found
                  </td>
                </tr>
              ) : (
                paginatedHistory.map((log, index) => {
                  const formattedDate = log.created_at 
                    ? new Date(log.created_at).toLocaleString('en-GB', { hour12: true }) 
                    : "N/A";

                  const isFailed = log.status === 'failed';

                  return (
                    <tr key={index} style={{ borderBottom: '1px solid var(--border)' }}>
                      <td style={{ padding: '1rem', fontFamily: 'monospace', color: 'var(--text-main)' }}>{formattedDate}</td>
                      <td style={{ padding: '1rem' }}>
                        <span style={{ 
                          background: log.origin === 'api' ? 'rgba(99, 102, 241, 0.15)' : 'rgba(16, 185, 129, 0.15)', 
                          color: log.origin === 'api' ? 'var(--primary)' : 'var(--success)', 
                          padding: '4px 8px', borderRadius: '6px', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase'
                        }}>
                          {log.origin || "dashboard"}
                        </span>
                      </td>
                      <td style={{ padding: '1rem', color: 'var(--text-main)' }}>
                        {log.message ? log.message.substring(0, 40) + (log.message.length > 40 ? "..." : "") : "Empty"}
                      </td>
                      <td style={{ padding: '1rem', color: 'var(--text-main)' }}>{log.phones || "Empty"}</td>
                      <td style={{ padding: '1rem', fontFamily: 'monospace', color: 'var(--text-muted)' }}>
                        KES {log.charge ? parseFloat(log.charge).toFixed(2) : "0.00"}
                      </td>
                      <td style={{ padding: '1rem' }}>
                        <span style={{ 
                          color: isFailed ? 'var(--danger)' : (log.runningstatus === 'completed' || log.status === 'success' ? 'var(--success)' : 'var(--warning)'), 
                          fontWeight: 600, fontSize: '0.85rem'
                        }}>
                          {log.status || "pending"}
                        </span>
                      </td>
                      <td style={{ padding: '1rem', color: 'var(--text-main)' }}>{log.webhookstatus || "-"}</td>
                      <td style={{ padding: '1rem' }}>
                        {isFailed ? (
                          <button 
                            type="button" 
                            onClick={() => handleRetryMessage(log.id)} 
                            style={{ background: 'rgba(56, 189, 248, 0.15)', color: '#38bdf8', border: '1px solid rgba(56, 189, 248, 0.3)', padding: '4px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 'bold' }}>
                            Retry
                          </button>
                        ) : (
                          <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>-</span>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* HISTORY PAGINATION CONTROLS */}
        {historyData.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', alignItems: 'center', marginTop: '1rem', fontSize: '0.85rem' }}>
            <button onClick={() => setHistPage(p => Math.max(1, p - 1))} disabled={histPage === 1} style={{ background: 'none', border: '1px solid var(--border)', color: 'var(--text-main)', padding: '4px 12px', borderRadius: '4px', cursor: histPage === 1 ? 'not-allowed' : 'pointer' }}>Prev</button>
            <span style={{ color: 'var(--text-muted)' }}>Page {histPage} of {totalHistPages}</span>
            <button onClick={() => setHistPage(p => Math.min(totalHistPages, p + 1))} disabled={histPage === totalHistPages} style={{ background: 'none', border: '1px solid var(--border)', color: 'var(--text-main)', padding: '4px 12px', borderRadius: '4px', cursor: histPage === totalHistPages ? 'not-allowed' : 'pointer' }}>Next</button>
          </div>
        )}

      </div>
    </div>
  );
};

export default MessagingPage;